<template>
     <el-dialog
              title="关于我们"
              :visible.sync="dialogVisible"
              :modal-append-to-body="false"
              :before-close="close"
              width="526px">
             <el-form ref="form" label-width="150px">
                   <el-form-item label="产品名称">
                      {{data.productname}}
                  </el-form-item>
                    <el-form-item label="型号、规格">
                      {{data.model}}
                  </el-form-item>
                     <el-form-item label="发布版本号">
                      {{data.publishversion}}
                  </el-form-item>
                     <el-form-item label="完整版本号">
                      {{data.intactversion}}
                  </el-form-item>
                <el-form-item>
                       <template slot="label">
                          <div style="lineHeight:20px;">注册人/生产<br/>企业/售后服务</div>
                      </template>
                      <div style="lineHeight:20px;">{{data.registrant}}</div>
                  </el-form-item>
                 <el-form-item label="注册人住所">
                    {{data.registradress}}
                  </el-form-item>
                    <el-form-item label="生产地址">
                     {{data.produceadress}}
                  </el-form-item>
                    <el-form-item label="联系方式">
                     <div  v-html="data.contact"></div>
                  </el-form-item>
                  <el-form-item label="医疗器械注册证编号">
                    {{data.registnumber}}
                  </el-form-item>
                   <el-form-item label="生产许可证编号">
                    {{data.producelicense}}
                  </el-form-item>
                   <el-form-item label="生产日期/生产批号">
                    {{data.producedate}}
                  </el-form-item>
                  <el-form-item label="有效期限">
                     {{data.validperiod}}
                  </el-form-item>
             </el-form>
            </el-dialog>
</template>
<script>
import { getproductinfo } from "@/api/user"
export default {
    name:'about',
    props:{
        dialogVisible:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            data: {}
        }
    },
    watch: {
        dialogVisible: {
            handler(newVal,oldVal) {
        　　  if(newVal){
                    this.getproductinfo()
                }
        　},
        　immediate: true
        }
    },
    methods:{
        close(){
            this.$emit('closeDialog',false)
        },
        getproductinfo(){
            getproductinfo().then(res=>{
                this.data = res.list?res.list[0]:{}
            })
        }
    }
}
</script>
